import { ProductGrid } from './product_grid';
import { ViewController } from './view_controller';
import {BundleGrid} from "./bundle_grid";

export class CollectionPage {
    constructor(loader, cart, body, popup) {
        this.loader = loader;
        this.cart = cart;
        this.popup = popup;
                
        const viewControlContainers = jQuery('.v4-ordering-control'), viewControllers = [];
        for (let i = 0; i < viewControlContainers.length; ++i)
            viewControllers.push(new ViewController(viewControlContainers.eq(i)));
        this.viewControllers = viewControllers;

        const gridContainers = jQuery('.v4-product-grid'), grids = [];
        for (let i = 0; i < gridContainers.length; ++i) {
            grids.push(new ProductGrid(loader, gridContainers.eq(i), this.popup));
        }
        this.grids = grids;
    }
}
